import { useEffect } from 'react'

const GTM_ID = 'GTM-MQQRNT4K'
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
const NOSCRIPT_SRC = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

/** Inyecta Google Tag Manager (script + fallback noscript) una sola vez. */
export function useGoogleTagManager(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${GTM_SRC}"]`)) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.async = true
    script.src = GTM_SRC

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }

    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = NOSCRIPT_SRC
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)
  }, [])
}
